import { render, staticRenderFns } from "./IdAdditionalFields.vue?vue&type=template&id=62fc0974&"
import script from "./IdAdditionalFields.vue?vue&type=script&lang=js&"
export * from "./IdAdditionalFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports